import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Login from './components/auth/login/Login';
import Onboarding from './components/auth/onboarding/Onboarding';
import OnboardingActivationPage from './components/auth/onboarding/OnboardingActivationPage';
import ThankYouRegistrationPage from './components/auth/onboarding/ThankYouRegistrationPage';
import TermsOfService from './components/terms/TermsOfService';
import PrivacyPolicy from './components/terms/PrivacyPolicy';
import UserSettings from './components/account/UserSettings';
import AppUserHome from './components/content/AppUserHome';
import ResetPassword from './components/account/ResetPassword';
import ChangePassword from './components/account/ChangePasswordAfterReset';
import ResetPasswordSuccess from './components/account/ResetPasswordSuccess';
import Newsletter from './components/content/Newsletter';
import Home from './components/home/Home';
import LimitedAccessRoute from './components/auth/LimitedAccessRoute';
import NotFoundPage from './components/common/404';
import { LOGIN_URL, ONBOARDING_URL, PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL, ONBOARDING_THANK_YOU_URL, ONBOARDING_ACTIVATE_URL, USER_SETTINGS_URL, CHANGE_PASSWORD_REDIRECT_URL, RESET_PASSWORD_REDIRECT_URL, RESET_PASSWORD_SUCCESS_REDIRECT_URL } from './utils/redirect-const';
import { ROLE_ADMIN, ROLE_APP_USER, ROLE_GUEST } from './utils/roles';
import './index.css';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function App() {
  const auth = useSelector((state) => state.auth);

  if (!GOOGLE_CLIENT_ID) {
    console.error('Google Client ID is not set. Please check your environment variables.');
    return null;
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<LimitedAccessRoute element={<Home />} auth={auth} allowRole={[ROLE_GUEST, ROLE_ADMIN, ROLE_APP_USER]} />} />
          <Route path="/encyklopedia/:productId?" element={<LimitedAccessRoute element={<AppUserHome />} auth={auth} allowRole={[ROLE_ADMIN, ROLE_APP_USER]} />} />
          <Route path="/przepisy/:recipeId?" element={<LimitedAccessRoute element={<AppUserHome />} auth={auth} allowRole={[ROLE_ADMIN, ROLE_APP_USER]} />} />
{/*         <Route path="/newsletter" element={<LimitedAccessRoute element={<Newsletter />} auth={auth} allowRole={[ROLE_GUEST, ROLE_ADMIN, ROLE_APP_USER]} />} /> */}
          <Route path={LOGIN_URL} element={<LimitedAccessRoute element={<Login />} auth={auth} allowRole={[ROLE_GUEST]} />} />
          <Route path={ONBOARDING_URL} element={<LimitedAccessRoute element={<Onboarding />} auth={auth} allowRole={[ROLE_GUEST]} />} />
          <Route path={ONBOARDING_THANK_YOU_URL} element={<LimitedAccessRoute element={<ThankYouRegistrationPage />} auth={auth} allowRole={[ROLE_GUEST]} />} />
          <Route path={RESET_PASSWORD_REDIRECT_URL} element={<LimitedAccessRoute element={<ResetPassword />} auth={auth} allowRole={[ROLE_GUEST]} />} />
          <Route path={RESET_PASSWORD_SUCCESS_REDIRECT_URL} element={<LimitedAccessRoute element={<ResetPasswordSuccess />} auth={auth} allowRole={[ROLE_GUEST]} />} />
          <Route path={`${CHANGE_PASSWORD_REDIRECT_URL}/:resetPasswordRequestId`} element={<LimitedAccessRoute element={<ChangePassword />} auth={auth} allowRole={[ROLE_GUEST]} />} />
          <Route path={TERMS_OF_SERVICE_URL} element={<LimitedAccessRoute element={<TermsOfService />} auth={auth} allowRole={[ROLE_GUEST, ROLE_ADMIN, ROLE_APP_USER]} />} />
          <Route path={PRIVACY_POLICY_URL} element={<LimitedAccessRoute element={<PrivacyPolicy />} auth={auth} allowRole={[ROLE_GUEST, ROLE_ADMIN, ROLE_APP_USER]} />} />
          <Route path={`${ONBOARDING_ACTIVATE_URL}/:confirmationId`} element={<LimitedAccessRoute element={<OnboardingActivationPage />} auth={auth} allowRole={[ROLE_GUEST, ROLE_ADMIN, ROLE_APP_USER]} />} />
          <Route path={USER_SETTINGS_URL} element={<LimitedAccessRoute element={<UserSettings />} auth={auth} allowRole={[ROLE_APP_USER]} />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;